import { createAxiosClient } from "@ntg/component-library/utilities";
import { useMutation } from "@tanstack/react-query";
import { ITwoFAPayload } from "../Declarations";

// Input required to verify the 2FA code
export interface IVerify2FARequest extends ITwoFAPayload {
    AuthCode: string;
}

// The response could be anything your API returns, so type as unknown
export type Verify2FAResponse = {
    LoginMessage: string;
    ValidCode: boolean;
};

export const useVerify2FA = () =>
    useMutation<Verify2FAResponse, unknown, IVerify2FARequest>({
        mutationFn: async (input: IVerify2FARequest): Promise<Verify2FAResponse> => {
            const axiosAuth = createAxiosClient("Auth");

            const response = await axiosAuth.post<Verify2FAResponse>(
                "/UILogin/Authenticate2FACode",
                {
                    AuthCode: input.AuthCode,
                    BrowserFingerprint: input.BrowserFingerprint,
                    Password: input.Password,
                    UserAgent: input.UserAgent,
                    UserID: input.UserID,
                    UserName: input.UserName,
                },
                {
                    headers: {
                        "Content-Type": "application/json",
                    },
                }
            );

            return response.data;
        },
    });
